import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import { useSelector } from 'react-redux';
import DetailProduct from './DetailProduct';
import HomeScreen from './home';
import LiquoursScreen from './liquours';
import BottlesScreen from './bottles';
import BeersScreen from './beers';
import { store } from '../../redux/store';
import { setGoHome } from '../../redux/slices/initLoad/types';

function Index() {
    
    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [dishs, setdishs] = useState(false);
    const [showHome, setshowHome] = useState(false);
    const [showLiquours, setshowLiquours] = useState(false);
     const [dataCocktail, setdataCocktail] = useState (false);
    const [dataDrinks, setdataDrinks] = useState(false);
    const [showListProduct2, setShowListProduct2] = useState(false);
     const [showCategories, setshowCategories] = useState(false);
     const [showBottles, setShowBottles] = useState(false);
     const [showBeers, setShowBeers] = useState(false);


     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
            if (item.id === 290) {
                setdataCocktail(item);
            }

            if (item.id === 288) {
                setdataDrinks(item);
            }
        });
      }, [menus]);
    


    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <div style={{
            minHeight: '100vh',
            width: '100%',
            background: 'linear-gradient(180deg, #E6D6EC 0%, #AD00FD 40%, #F00101 69%, #000000 100%)',
            backgroundAttachment: 'fixed',
            position: 'relative'
        }}>
            {/* Overlay oscuro */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.45)',
                    pointerEvents: 'none',
                    zIndex: 1,
                }}
            />

            {/* Contenido por encima del overlay */}
            <div style={{ position: 'relative', zIndex: 2 }}>
                <center style={{ width: '100%', position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%'}}>
                        <div
                            onClick={() => {
                                 store.dispatch(setGoHome(!goHomeInit));
                            }}
                           
                                style={{
                                  width: 140,
                                  height: 40,
                                  display: 'flex',
                                  textAlign: 'center',
                                  alignItems: 'center',
                                  justifyContent: "center",
                                  cursor: 'pointer',
                               
                                margin: '0 auto',
                                marginTop: 50,
                                    marginBottom: 50,
                                  zIndex: 999,
                                  position: 'relative',
                                  background: "#C70100",
                                  borderRadius: 10,
                                    background: "#FEBA29",
                                  paddingInline: 10,
                                  boxSizing: 'border-box',
                                  border: '2px solid white',
                                    boxShadow: "0px 0px 20px rgba(255, 215, 0, 0.9)",
                            }}>
                           
                        <p style={{ position: 'absolute', color: 'white', fontSize: 20, fontWeight: '900' , textTransform: "uppercase"}}>
                          
                          {langEng ? 'GO BACK' : 'Ir atras'}
                          </p>
                          </div>
                   
                   
                </center>
            </div>

            <div>
                <div style={{position: 'relative', zIndex: 2}} onClick={() => {
                     setdishs(dataCocktail)
                                setShowListProduct2(true)
                }}>
                    <img src={require('./assets/coctailbtn.png')} alt="logo"  style={{width: 500, height: 250, objectFit: 'contain'}}/>
                    </div>
                    
                <div style={{position: 'relative', zIndex: 2}} onClick={() => {
                    setShowBottles(true)
                }}>
                    <img style={{width: 500, height: 250, objectFit: 'contain'}} src={require('./assets/bottlebtn.png')} alt="logo" />
                    </div>
                    
                    <div style={{position: 'relative', zIndex: 2}} onClick={() => {
                    setShowBeers(true)
                }}>
                    <img  style={{width: 500, height: 250, objectFit: 'contain'}} src={require('./assets/beersbtn.png')} alt="logo" />
                </div>

            </div>

            {showListProduct2 && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct2}
                    goHome={setshowCategories}
                />}
                 {showBottles && <BottlesScreen setShowListProduct={setShowBottles} setShowHappy={setshowCategories} />}
{showBeers && <BeersScreen setShowListProduct={setShowBeers} setShowHappy={setshowCategories} />}

            </div>
            </div>
    );
}

export default Index;